import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Sparkles, RefreshCw } from 'lucide-react';
import { axios, auth, mbUrl, muted, primary, card, runCall } from './mbApi';

const FIELDS = [
  ['min_joins_first', 'Min join unik / versi'], ['min_spend_myr', 'Min spend (RM)'], ['min_days', 'Min hari data'],
  ['baseline_min_myr', 'Baseline CPS unik min (RM)'], ['baseline_max_myr', 'Baseline CPS unik max (RM)'], ['stale_hours', 'Data lapuk selepas (jam)'],
];

export const AnalystConfigCard = ({ ibId, analyst, error, onRetry, onSaved }) => {
  const [cfg, setCfg] = useState(analyst?.cfg || {});
  const [tags, setTags] = useState((analyst?.angle_tags || []).join('\n'));
  const [busy, setBusy] = useState(false);
  useEffect(() => { setCfg(analyst?.cfg || {}); setTags((analyst?.angle_tags || []).join('\n')); }, [analyst]);
  const save = () => runCall(setBusy, async () => {
    await axios.put(mbUrl(ibId, '/analyst/config'), { cfg, angle_tags: tags.split('\n').map((t) => t.trim()).filter(Boolean) }, auth());
    onSaved();
  }, 'Tetapan analisis disimpan');
  return (
    <div className={`${card} space-y-3`} data-testid="mb-analyst-config">
      <p className={`text-base font-semibold ${primary} flex items-center gap-2`}><Sparkles size={16} className="text-[#F77F00]" /> Tetapan AI Creative Analyst</p>
      {error && (
        <div className="text-sm text-red-400 space-y-2" data-testid="mb-analyst-config-error">
          <p>{error} — tetapan belum dimuat, Simpan dikunci supaya nilai sedia ada tak ditimpa.</p>
          <Button variant="outline" className="h-10" onClick={onRetry} data-testid="mb-analyst-config-retry"><RefreshCw size={14} className="mr-1.5" /> Cuba lagi</Button>
        </div>
      )}
      {!analyst && !error && <p className={`text-sm ${muted}`} data-testid="mb-analyst-config-loading">Memuat tetapan…</p>}
      <p className={`text-xs ${muted}`}>Analisis manual sahaja (tiada auto selepas sync). AI tiada kuasa ke atas iklan, budget atau status campaign. Model: {analyst?.model || '—'}.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {FIELDS.map(([k, label]) => (
          <div key={k} className="space-y-1">
            <Label htmlFor={`mb-analyst-cfg-${k}`} className={`text-xs ${muted}`}>{label}</Label>
            <Input id={`mb-analyst-cfg-${k}`} type="number" className="h-10" disabled={!analyst} value={cfg[k] ?? ''}
              onChange={(e) => setCfg({ ...cfg, [k]: e.target.value === '' ? '' : Number(e.target.value) })} data-testid={`mb-analyst-cfg-${k}`} />
          </div>
        ))}
      </div>
      <div className="space-y-1">
        <Label htmlFor="mb-analyst-tags" className={`text-xs ${muted}`}>Tag angle standard (satu baris satu tag)</Label>
        <Textarea id="mb-analyst-tags" rows={5} disabled={!analyst} value={tags} onChange={(e) => setTags(e.target.value)} data-testid="mb-analyst-tags" />
      </div>
      <Button className="h-10" disabled={busy || !analyst} onClick={save} data-testid="mb-analyst-config-save">Simpan tetapan analisis</Button>
    </div>
  );
};
